import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import { Figure } from "react-bootstrap";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SVG from "react-inlinesvg";
import { CardBody, CardFooter } from "../../../../_metronic/_partials/controls";
import { Select } from "../../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as reqDistrict from "../../MasterData/_redux/province/provinceCrud";
import {
  getOrganizationInitialValues,
  getImageUrl
} from "../OrganizationUIHelpers";
import { ActionButton } from "../../../../_metronic/_partials/controls/ActionButton";
import { useSelector } from "react-redux";
import GoogleMapsForm from "./GoogleMapsForm";

const OrganizationSchema = Yup.object().shape({
  name: Yup.string().required("Nama wajb diisi"),
  domain_name: Yup.string().required("Domain wajb diisi")
});

const OrganizationEditForm = ({ organization, saveOrganization }) => {
  const { actionsLoading } = useSelector(({ organizations }) => ({
    actionsLoading: organizations.actionsLoading
  }));

  const [kotaValue, setKotaValue] = useState("");
  const [postalCode, setPostalCode] = useState([]);
  const [district, setDistrict] = useState([]);

  useEffect(() => {
    if (organization) {
      setKotaValue(
        `${
          organization.district ? organization.district + "," : ""
        } ${organization.city + ","} ${organization.province}`
      );
      setPostalCode([organization.postal_code]);
    }
  }, [organization]);

  const onInputChange = e => {
    const value = e.target.value;

    if (value.length >= 3) {
      let query = {
        district: value,
        city: value
      };
      reqDistrict.findDistrict(query).then(response => {
        setDistrict(response.data.data);
      });
    }
  };

  const onSelectTag = (value, setFieldValue) => {
    const array = value.split(",");
    if (array.length === 3) {
      let index = district.findIndex(
        i =>
          i.district === array[0].trim() &&
          i.city === array[1].trim() &&
          i.province_name === array[2].trim()
      );
      setPostalCode(district[index].postalcode);
      setFieldValue("province", district[index].province_name);
      setFieldValue("city", district[index].city);
      setFieldValue("district", district[index].district);
      setKotaValue(
        `${district[index].district}, ${district[index].city}, ${district[index].province_name}`
      );
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={getOrganizationInitialValues(organization)}
      validationSchema={OrganizationSchema}
      onSubmit={values => {
        saveOrganization(values);
      }}
    >
      {({ setFieldValue, values, handleSubmit }) => (
        <Form>
          <CardBody>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Nama Lembaga
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="name"
                  placeholder="Nama Lembaga"
                  className={`form-control form-control-lg`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">Domain</label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="domain_name"
                  disabled={true}
                  placeholder="Domain"
                  className={`form-control form-control-m form-control-solid`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Nama Bank
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="bank_name"
                  placeholder="Nama Bank (BSI/BNI/BCA)"
                  className={`form-control form-control-lg`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Rekening Bank
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="bank_account"
                  placeholder="No rekening bank (12345)"
                  className={`form-control form-control-lg`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Atas Nama Bank
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="bank_account_behalf"
                  placeholder="Masukkan atas nama bank"
                  className={`form-control form-control-lg`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Logo Lembaga
              </label>
              <div className="col-4 d-flex flex-column">
                {values.file && (
                  <Figure className="position-relative">
                    {!values.delete_image && (
                      <Figure.Image src={getImageUrl(values.file)} />
                    )}
                    <div
                      className="position-absolute btn btn-icon btn-light btn-hover-danger btn-sm"
                      style={{ top: 0, right: 0 }}
                      onClick={() => {
                        setFieldValue("file", null);
                        setFieldValue("delete_image", true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Trash.svg"
                          )}
                        />
                      </span>
                    </div>
                  </Figure>
                )}
                <input
                  type="file"
                  name="file"
                  placeholder="Text"
                  label="Name"
                  onChange={e => setFieldValue("file", e.target.files[0])}
                />
              </div>
            </div>

            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Kota dan Kecamatan
              </label>
              <div className="col-lg-9 col-xl-6">
                <Autocomplete
                  id="searchPostalCode"
                  disableClearable
                  onChange={(e, value) => {
                    onSelectTag(value, setFieldValue);
                  }}
                  value={kotaValue}
                  options={district.map(
                    option =>
                      `${option.district}, ${option.city}, ${option.province_name}`
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Cari Kota / Kecamatan"
                      margin="normal"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={e => {
                        onInputChange(e);
                      }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">Alamat</label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="address"
                  placeholder="Address"
                  className={`form-control form-control-lg`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Kode Pos
              </label>
              <div className="col-lg-9 col-xl-6">
                <Select
                  name="postal_code"
                  value={values.postal_code}
                  onChange={e => {
                    setFieldValue("postal_code", e.target.value);
                  }}
                >
                  <option value="">-PILIH-</option>
                  {postalCode.map((row, index) => {
                    return (
                      <option key={`${row}-${index}`} value={row}>
                        {row}
                      </option>
                    );
                  })}
                </Select>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                No HP PIC
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="call_center"
                  placeholder="No HP PIC"
                  className={`form-control form-control-m`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Instagram
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="instagram"
                  placeholder="Instagram"
                  className={`form-control form-control-m`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Facebook
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="facebook"
                  placeholder="Facebook"
                  className={`form-control form-control-m`}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Twitter
              </label>
              <div className="col-lg-9 col-xl-6">
                <Field
                  name="twitter"
                  placeholder="Twitter"
                  className={`form-control form-control-m`}
                />
              </div>
            </div>
            <GoogleMapsForm setFieldValue={setFieldValue} values={values} />
          </CardBody>
          <CardFooter>
            <div className="d-flex justify-content-end">
              <ActionButton
                onClick={handleSubmit}
                text="Save"
                loading={actionsLoading}
              />
            </div>
          </CardFooter>
        </Form>
      )}
    </Formik>
  );
};

export default OrganizationEditForm;
